/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Serialized as ISO 8601 string */
  Date: { input: string; output: string; }
  /**
   * The implementation for this scalar is provided by the
   * 'GraphQLUpload' export from the 'graphql-upload' package
   */
  FileUpload: { input: File; output: File; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Animation = Presentation & {
  __typename?: 'Animation';
  /** Detailed information about presentation asset */
  asset: Maybe<Asset>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Product the animation belongs to */
  product: Maybe<Product>;
  /** Id of product the animation belongs to */
  productId: Maybe<Scalars['ID']['output']>;
  /** Resolution of asset before it was trimmed (in px) */
  referenceResolution: Scalars['Int']['output'];
  /** Url to thumbnail of animation */
  thumbnailUrl: Scalars['String']['output'];
  /** Type of presentation */
  type: PresentationType;
  /** Url to animation */
  url: Scalars['String']['output'];
};

export type Asset = {
  __typename?: 'Asset';
  /** Height of image (in px) */
  height: Scalars['Int']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Mime type of image */
  mimeType: Scalars['String']['output'];
  /** Url to thumbnail of image */
  thumbnailUrl: Scalars['String']['output'];
  /** Url to image */
  url: Scalars['String']['output'];
  /** Width of image (in px) */
  width: Scalars['Int']['output'];
};

export type Background = {
  __typename?: 'Background';
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Readable name */
  name: Maybe<Scalars['String']['output']>;
  /** Tags of background */
  tags: Array<Scalars['String']['output']>;
  /** Url to show thumbnail of background */
  thumbnailUrl: Scalars['String']['output'];
  /** Url to background */
  url: Scalars['String']['output'];
};

export type BackgroundFilter = {
  /** Generic field filters */
  fields?: InputMaybe<Array<FieldFilter>>;
  /** Filter by name */
  name?: InputMaybe<NameFilter>;
  /** Filter by tags */
  tags?: InputMaybe<TagsFilter>;
};

export type BackgroundQuery = {
  /** Filter to use */
  filter?: InputMaybe<BackgroundFilter>;
  /** Pagination to use */
  pagination?: InputMaybe<Pagination>;
};

export type Brand = {
  __typename?: 'Brand';
  /** Unique identifier of the brand */
  id: Scalars['ID']['output'];
  /** Name of the brand */
  name: Scalars['String']['output'];
};

export type Client = {
  __typename?: 'Client';
  /** Indicates if client can adapt labels */
  canAdaptLabel: Scalars['Boolean']['output'];
  /** Indicates if client can enable shadows & reflections */
  canUseShadowsAndReflections: Scalars['Boolean']['output'];
  /** Default aspect ratio to use for layouts in the client's layouts */
  defaultAspectRatio: Maybe<Scalars['Float']['output']>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Url to logo image */
  logoUrl: Maybe<Scalars['String']['output']>;
  /** Name */
  name: Maybe<Scalars['String']['output']>;
};

export type CreateBackgroundError = {
  __typename?: 'CreateBackgroundError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type CreateBackgroundInput = {
  /**
   * Id of group to add background to
   * @default Adds it to a default background group if set
   */
  groupId?: InputMaybe<Scalars['String']['input']>;
  /** Image to use */
  image: Scalars['FileUpload']['input'];
  /** Name of background */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBackgroundResult = CreateBackgroundError | CreateBackgroundSuccess;

export type CreateBackgroundSuccess = {
  __typename?: 'CreateBackgroundSuccess';
  /** Created background */
  background: Background;
};

export type CreateGraphicError = {
  __typename?: 'CreateGraphicError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type CreateGraphicInput = {
  /** File to use */
  file: Scalars['FileUpload']['input'];
  /** Name of graphic */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGraphicResult = CreateGraphicError | CreateGraphicSuccess;

export type CreateGraphicSuccess = {
  __typename?: 'CreateGraphicSuccess';
  /** Created graphic */
  graphic: Graphic;
};

export type CreateLayoutInput = {
  /** Name of layout */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Id of project to create the layout for */
  projectId: Scalars['String']['input'];
  /** Setup of background to use */
  renderingBackground?: InputMaybe<RenderingBackgroundInput>;
  /** Objects to render */
  renderingObjects?: InputMaybe<Array<CreateRenderingObjectInput>>;
  /**
   * Status
   * @default LayoutStatus.Active
   */
  status?: InputMaybe<LayoutStatus>;
};

export type CreateProductInput = {
  /**
   * Indicates if the product is approved.
   * Only approved products will generate presentation assets and are displayed in the UI
   */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifiers of clients the product is for */
  clientIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Id of flight in Coach */
  flightId: Scalars['String']['input'];
  /** Possible inputs for product */
  inputs?: InputMaybe<Array<CreateProductInputInput>>;
  /** Name of product */
  name: Scalars['String']['input'];
  /** Presentations for product */
  presentations?: InputMaybe<Array<CreateProductPresentationInput>>;
};

export type CreateProductInputInput = {
  /** Default asset to use */
  asset?: InputMaybe<Scalars['FileUpload']['input']>;
  /** Identifier */
  identifier: Scalars['String']['input'];
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductPresentationInput = {
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Take */
  take: Scalars['String']['input'];
  /** Type */
  type: PresentationType;
};

export type CreateProjectInput = {
  /** Name of project */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Workspace to create the project in */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRenderingJob = {
  /** Setup of background to use */
  background?: InputMaybe<RenderingBackgroundInput>;
  /** Objects to render */
  objects?: InputMaybe<Array<CreateRenderingObjectInput>>;
  /**
   * Render reflections
   * @default false
   */
  reflections?: InputMaybe<Scalars['Boolean']['input']>;
  /** Generic renderings settings */
  settings?: InputMaybe<Array<CreateRenderingJobSetting>>;
  /**
   * Render shadows
   * @default false
   */
  shadows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateRenderingJobError = {
  __typename?: 'CreateRenderingJobError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type CreateRenderingJobResult = CreateRenderingJobError | CreateRenderingJobSuccess;

export type CreateRenderingJobSetting = {
  /** Unique setting identifier */
  identifier: Scalars['String']['input'];
  /** Value to use */
  value: Scalars['String']['input'];
};

export type CreateRenderingJobSuccess = {
  __typename?: 'CreateRenderingJobSuccess';
  /** Created rendering job */
  job: RenderingJob;
};

export type CreateRenderingObjectInput = {
  /**
   * Id of graphic
   * Either presentationId or graphicId must be set
   */
  graphicId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Offset of object
   * @default (0,0)
   */
  offset?: InputMaybe<PackshotOffsetInput>;
  /**
   * Id of presentation
   * Either presentationId or graphicId must be set
   */
  presentationId?: InputMaybe<Scalars['ID']['input']>;
  /** Product inputs to use for rendering */
  productInputs?: InputMaybe<Array<CreateRenderingObjectProductInputInput>>;
  /**
   * Scale factor of object
   * @default 1
   */
  scale?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateRenderingObjectProductInputInput = {
  /** File to use */
  file: Scalars['FileUpload']['input'];
  /** Identifier of product input */
  identifier: Scalars['String']['input'];
};

export type DuplicateLayoutInput = {
  /** Id of layout to duplicate */
  layoutId: Scalars['String']['input'];
  /**
   * Name of new layout
   * @default Name of original layout + " (Copy)"
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Id of project to add duplicated layout to
   * @default Project of original layout
   */
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateProjectInput = {
  /**
   * Name of new project
   * @default Name of original project + " (Copy)"
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Id of project to duplicate */
  projectId: Scalars['String']['input'];
  /** Workspace to create the new project in */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type FieldFilter = {
  /** Returns items that have any of the specified values */
  anyOf?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of field this filter is for */
  fieldName: Scalars['String']['input'];
};

export type FieldFilterDefinition = {
  __typename?: 'FieldFilterDefinition';
  /** Name of field this filter is for */
  fieldName: Scalars['String']['output'];
  /** Readable name of filter */
  name: Scalars['String']['output'];
  /** Available options for filter */
  options: Array<FieldFilterOption>;
};

export type FieldFilterOption = {
  __typename?: 'FieldFilterOption';
  /** Label to display option */
  label: Scalars['String']['output'];
  /** Value of option */
  value: Scalars['String']['output'];
};

export type Graphic = {
  __typename?: 'Graphic';
  /** Detailed information about asset */
  asset: Asset;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Readable name */
  name: Maybe<Scalars['String']['output']>;
  /** Url to preview graphic */
  previewUrl: Scalars['String']['output'];
};

export type GraphicFilter = {
  /** Generic field filters */
  fields?: InputMaybe<Array<FieldFilter>>;
  /** Filter by name */
  name?: InputMaybe<NameFilter>;
};

export type GraphicQuery = {
  /** Filter to use */
  filter?: InputMaybe<GraphicFilter>;
  /** Pagination to use */
  pagination?: InputMaybe<Pagination>;
};

export type Language = {
  __typename?: 'Language';
  /** Unique identifier of the language */
  id: Scalars['ID']['output'];
  /** Name of the language */
  name: Scalars['String']['output'];
};

export type Layout = {
  __typename?: 'Layout';
  /** Aspect ratio the layout will be rendered in */
  aspectRatio: Maybe<Scalars['Float']['output']>;
  /** Moment when the layout was created */
  createdAt: Scalars['Date']['output'];
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Latest rendering job for layout */
  latestRenderingJob: Maybe<RenderingJob>;
  /** Name of layout */
  name: Maybe<Scalars['String']['output']>;
  /** Latest preview rendering job for layout */
  previewRenderingJob: Maybe<RenderingJob>;
  /** Project the layout belongs to */
  project: Maybe<Project>;
  /** Id of project the layout belongs to */
  projectId: Maybe<Scalars['String']['output']>;
  /** Indicates if logged in user has read-only access to the layout */
  readOnly: Maybe<Scalars['Boolean']['output']>;
  /** Setup of background to use */
  renderingBackground: Maybe<RenderingBackground>;
  /** Objects to render */
  renderingObjects: Maybe<Array<RenderingObject>>;
  /** Current rendering progress */
  renderingProgress: Maybe<LayoutRenderingProgress>;
  /** Status */
  status: LayoutStatus;
  /** Url to thumbnail of layout */
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  /** Moment when the layout was updated */
  updatedAt: Maybe<Scalars['Date']['output']>;
};

export type LayoutFilter = {
  /** Filter by name */
  name?: InputMaybe<NameFilter>;
  /** Filter by project */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by rendering progress */
  renderingProgress?: InputMaybe<LayoutRenderingProgressFilter>;
  /** Filter by status */
  status?: InputMaybe<LayoutStatus>;
};

export type LayoutQuery = {
  /** Filter to use */
  filter?: InputMaybe<LayoutFilter>;
  /** Pagination to use */
  pagination?: InputMaybe<Pagination>;
  /** Fields to sort */
  sort?: InputMaybe<Array<LayoutSort>>;
};

export type LayoutQueryResult = QueryResult & {
  __typename?: 'LayoutQueryResult';
  /** Items that matched query, possibly limited to `limit` */
  items: Maybe<Array<Layout>>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum LayoutRenderingProgress {
  Failed = 'Failed',
  Generated = 'Generated',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  PreviewAvailable = 'PreviewAvailable',
  PreviewFailed = 'PreviewFailed',
  PreviewInProgress = 'PreviewInProgress'
}

export type LayoutRenderingProgressFilter = {
  /** Returns items that have any of the specified values */
  anyOf: Array<LayoutRenderingProgress>;
};

export type LayoutSort = {
  /**
   * Indicates if the sort should be descending.
   * By default it is sorted ascending.
   */
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  /** What field to sort by */
  field: LayoutSortField;
};

/** Possible fields to sort by */
export enum LayoutSortField {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

export enum LayoutStatus {
  Active = 'Active',
  Archived = 'Archived',
  /** @deprecated Use `Active` instead */
  Published = 'Published'
}

export type Maintenance = {
  __typename?: 'Maintenance';
  /** Moment the maintenance starts */
  from: Scalars['Date']['output'];
  /** Unique id */
  id: Scalars['String']['output'];
  /** Moment the maintenance ends */
  to: Scalars['Date']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a new background */
  createBackground: CreateBackgroundResult;
  /** Creates a new graphic */
  createGraphic: CreateGraphicResult;
  /** Creates a new layout with the specified data */
  createLayout: Layout;
  createProduct: Product;
  /** Creates a new project with the specified data */
  createProject: Project;
  /** Creates a new rendering job */
  createRenderingJob: CreateRenderingJobResult;
  /** Deletes the layout with the specified id */
  deleteLayout: Layout;
  /** Deletes the project with the specified if */
  deleteProject: Project;
  /** Creates a new layout by duplicating an existing one */
  duplicateLayout: Layout;
  /** Creates a new project by duplicating an existing one */
  duplicateProject: Project;
  /** Creates a new rendering job for a layout */
  renderLayout: CreateRenderingJobResult;
  /** Renders a preview for a layout */
  renderLayoutPreview: RenderLayoutPreviewResult;
  /** Renders multiple layout previews */
  renderLayoutPreviews: RenderLayoutPreviewsResult;
  /** Creates a new rendering job for multiple layouts */
  renderLayouts: RenderLayoutsResult;
  /** Updates the layout with the specified id */
  updateLayout: Layout;
  updateProduct: Product;
  /** Updates the project with the specified id */
  updateProject: Project;
};


export type MutationCreateBackgroundArgs = {
  input: CreateBackgroundInput;
};


export type MutationCreateGraphicArgs = {
  input: CreateGraphicInput;
};


export type MutationCreateLayoutArgs = {
  input: CreateLayoutInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateRenderingJobArgs = {
  input: CreateRenderingJob;
};


export type MutationDeleteLayoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateLayoutArgs = {
  input: DuplicateLayoutInput;
};


export type MutationDuplicateProjectArgs = {
  input: DuplicateProjectInput;
};


export type MutationRenderLayoutArgs = {
  input: RenderLayoutInput;
};


export type MutationRenderLayoutPreviewArgs = {
  input: RenderLayoutPreviewInput;
};


export type MutationRenderLayoutPreviewsArgs = {
  input: RenderLayoutPreviewsInput;
};


export type MutationRenderLayoutsArgs = {
  input: RenderLayoutsInput;
};


export type MutationUpdateLayoutArgs = {
  data: UpdateLayoutInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateProductArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProductInput;
};


export type MutationUpdateProjectArgs = {
  data: UpdateProjectInput;
  id: Scalars['ID']['input'];
};

export type NameFilter = {
  /** Term the name has to contain */
  contains?: InputMaybe<Scalars['String']['input']>;
};

export type PackshotOffset = {
  __typename?: 'PackshotOffset';
  /** Absolute horizontal offset from origin (in px) */
  x: Scalars['Float']['output'];
  /** Absolute vertical offset from origin (in px) */
  y: Scalars['Float']['output'];
};

export type PackshotOffsetInput = {
  /** Absolute horizontal offset from origin (in px) */
  x: Scalars['Float']['input'];
  /** Absolute vertical offset from origin (in px) */
  y: Scalars['Float']['input'];
};

export type Pagination = {
  /**
   * Set the maximum number of items that will be returned
   * @default 100
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Skip the first n items in the response
   * @default 0
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An alternative to offset.
   * Page is a way to set offset under the hood by calculating `limit * page`.
   * Page is 1-indexed.
   * If set it will be used over `offset`
   */
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Perspective = Presentation & {
  __typename?: 'Perspective';
  /** Detailed information about presentation asset */
  asset: Maybe<Asset>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Name of perspective */
  name: Maybe<Scalars['String']['output']>;
  /** Product the perspective belongs to */
  product: Maybe<Product>;
  /** Id of product the perspective belongs to */
  productId: Maybe<Scalars['ID']['output']>;
  /** Resolution of asset before it was trimmed (in px) */
  referenceResolution: Scalars['Int']['output'];
  /** Url to thumbnail of image of perspective */
  thumbnailUrl: Scalars['String']['output'];
  /** Type of presentation */
  type: PresentationType;
  /** Url to image of perspective */
  url: Scalars['String']['output'];
};

export type Presentation = {
  /** Detailed information about presentation asset */
  asset: Maybe<Asset>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Product the presentation belongs to */
  product: Maybe<Product>;
  /** Id of product the presentation belongs to */
  productId: Maybe<Scalars['ID']['output']>;
  /** Resolution of asset before it was trimmed (in px) */
  referenceResolution: Scalars['Int']['output'];
  /** Url to thumbnail */
  thumbnailUrl: Scalars['String']['output'];
  /** Type of presentation */
  type: PresentationType;
  /** Url to image of presentation */
  url: Scalars['String']['output'];
};

export enum PresentationType {
  Animation = 'Animation',
  Perspective = 'Perspective'
}

export type Product = {
  __typename?: 'Product';
  /** Animations of product */
  animations: Maybe<Array<Animation>>;
  /** Brand of the product */
  brand: Maybe<Brand>;
  /** Id of the brand */
  brandId: Maybe<Scalars['String']['output']>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Possible inputs for product */
  inputs: Maybe<Array<ProductInput>>;
  /** Language of the product */
  language: Maybe<Language>;
  /** Id of the language */
  languageId: Maybe<Scalars['String']['output']>;
  /** Name of product */
  name: Maybe<Scalars['String']['output']>;
  /** Perspectives of product */
  perspectives: Maybe<Array<Perspective>>;
  /** Presentations of product */
  presentations: Maybe<Array<Presentation>>;
  /** Type of the product */
  productType: Maybe<ProductType>;
  /** Id of the product type */
  productTypeId: Maybe<Scalars['String']['output']>;
  /** Sub-brand of the product */
  subBrand: Maybe<SubBrand>;
  /** Id of the sub-brand */
  subBrandId: Maybe<Scalars['String']['output']>;
  /** Subsidiary of the product */
  subsidiary: Maybe<Subsidiary>;
  /** Id of the subsidiary */
  subsidiaryId: Maybe<Scalars['String']['output']>;
  /** Tags of product */
  tags: Array<Scalars['String']['output']>;
  /** Url to thumbnail of product */
  thumbnailUrl: Maybe<Scalars['String']['output']>;
};

export type ProductFilter = {
  /** Generic field filters */
  fields?: InputMaybe<Array<FieldFilter>>;
  /** Filter by product name */
  name?: InputMaybe<NameFilter>;
  /** Filter by product tags */
  tags?: InputMaybe<TagsFilter>;
};

export type ProductInput = {
  __typename?: 'ProductInput';
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Identifier */
  identifier: Scalars['String']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
};

export type ProductQuery = {
  /** Filter to use */
  filter?: InputMaybe<ProductFilter>;
  /** Pagination to use */
  pagination?: InputMaybe<Pagination>;
};

export type ProductType = {
  __typename?: 'ProductType';
  /** Unique identifier of the product type */
  id: Scalars['ID']['output'];
  /** Name of the product type */
  name: Scalars['String']['output'];
};

export type Project = {
  __typename?: 'Project';
  /** Moment when the project was created */
  createdAt: Scalars['Date']['output'];
  /** Unique id */
  id: Scalars['ID']['output'];
  /**
   * Moment when the project was last edited.
   * This includes updates to the project as well as the current layouts of the project
   */
  lastEditedAt: Maybe<Scalars['Date']['output']>;
  /** Number of layouts that belong to this project */
  layoutCount: Maybe<Scalars['Int']['output']>;
  /** Layouts that belong to this project */
  layouts: Maybe<Array<Layout>>;
  /** Name of project */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if logged in user has read-only access to the project */
  readOnly: Maybe<Scalars['Boolean']['output']>;
  /** Moment when the project was updated */
  updatedAt: Maybe<Scalars['Date']['output']>;
  /** Workspace the project belongs to */
  workspace: Maybe<Workspace>;
  /** Id of workspace the project belongs to */
  workspaceId: Maybe<Scalars['String']['output']>;
};

export type ProjectFilter = {
  /** Filter by name */
  name?: InputMaybe<NameFilter>;
  /** Filter by workspace */
  workspace?: InputMaybe<ProjectWorkspaceFilter>;
};

export type ProjectQuery = {
  /** Filter to use */
  filter?: InputMaybe<ProjectFilter>;
  /** Pagination to use */
  pagination?: InputMaybe<Pagination>;
  /** Fields to sort */
  sort?: InputMaybe<Array<ProjectSort>>;
};

export type ProjectQueryResult = QueryResult & {
  __typename?: 'ProjectQueryResult';
  /** Items that matched query, possibly limited to `limit` */
  items: Maybe<Array<Project>>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ProjectSort = {
  /**
   * Indicates if the sort should be descending.
   * By default it is sorted ascending.
   */
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  /** What field to sort by */
  field: ProjectSortField;
};

/** Possible fields to sort by */
export enum ProjectSortField {
  CreatedAt = 'CreatedAt',
  LastEditedAt = 'LastEditedAt',
  Name = 'Name',
  UpdatedAt = 'UpdatedAt'
}

export type ProjectWorkspaceFilter = {
  /** Id of workspace to filter projects by */
  equals?: InputMaybe<Scalars['String']['input']>;
  /** Filter projects that have no workspace if `True` */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Returns the animation with the specified id */
  animation: Animation;
  /** Returns all available animations */
  animations: Array<Animation>;
  /** Returns the background with the specified id */
  background: Background;
  /** Generic field filters for backgrounds */
  backgroundFilters: Array<FieldFilterDefinition>;
  /** Returns all backgrounds that fulfill the specified query */
  backgrounds: Array<Background>;
  /** Returns the graphic with the specified id */
  graphic: Graphic;
  /** Generic field filters for graphics */
  graphicFilters: Array<FieldFilterDefinition>;
  /** Returns all graphics that fulfill the specified query */
  graphics: Array<Graphic>;
  /** Returns the layout with the specified id */
  layout: Layout;
  /**
   * Returns the layouts that match the specified query.
   * Supports pagination.
   */
  layouts: LayoutQueryResult;
  /** Info about the logged in user */
  me: Maybe<User>;
  nextMaintenance: Maybe<Maintenance>;
  /** Returns the perspective with the specified id */
  perspective: Perspective;
  /** Returns all available perspectives */
  perspectives: Array<Perspective>;
  /** Returns the presentation with the specified id */
  presentation: Presentation;
  /** Returns all available presentations */
  presentations: Array<Presentation>;
  /** Returns the product with the specified id */
  product: Maybe<Product>;
  /** Generic field filters for products */
  productFilters: Array<FieldFilterDefinition>;
  /** Returns all products that fulfill the specified query */
  products: Array<Product>;
  /** Returns the project with the specified id */
  project: Project;
  /**
   * Returns the projects that match the specified query.
   * Supports pagination.
   */
  projects: ProjectQueryResult;
  /** Returns the rendering job with the specified id */
  renderingJob: RenderingJob;
  /** Available rendering settings */
  renderingSettings: RenderingSettings;
  workspaces: Array<Workspace>;
};


export type QueryAnimationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBackgroundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBackgroundsArgs = {
  query?: InputMaybe<BackgroundQuery>;
};


export type QueryGraphicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGraphicsArgs = {
  query?: InputMaybe<GraphicQuery>;
};


export type QueryLayoutArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLayoutsArgs = {
  query?: InputMaybe<LayoutQuery>;
};


export type QueryPerspectiveArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPresentationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  query?: InputMaybe<ProductQuery>;
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  query?: InputMaybe<ProjectQuery>;
};


export type QueryRenderingJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkspacesArgs = {
  query?: InputMaybe<WorkspaceQuery>;
};

export type QueryResult = {
  /**
   * Maximum number of items to return
   * Used for pagination.
   */
  limit: Maybe<Scalars['Int']['output']>;
  /**
   * Number of items to skip from result before returning.
   * Used for pagination.
   */
  offset: Maybe<Scalars['Int']['output']>;
  /**
   * An alternative to offset.
   * Page is a way to set offset under the hood by calculating `limit * page`.
   * Page is 1-indexed.
   * If set it will be used over `offset`
   */
  page: Maybe<Scalars['Int']['output']>;
  /** Total number of items that matched the query */
  totalCount: Scalars['Int']['output'];
};

export type RenderLayoutInput = {
  /** Id of layout to render */
  layoutId: Scalars['String']['input'];
  /**
   * Render reflections
   * @default false
   */
  reflections?: InputMaybe<Scalars['Boolean']['input']>;
  /** Generic renderings settings */
  settings?: InputMaybe<Array<CreateRenderingJobSetting>>;
  /**
   * Render shadows
   * @default false
   */
  shadows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RenderLayoutPreviewError = {
  __typename?: 'RenderLayoutPreviewError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type RenderLayoutPreviewInput = {
  /** Id of layout to render */
  layoutId: Scalars['String']['input'];
};

export type RenderLayoutPreviewResult = RenderLayoutPreviewError | RenderLayoutPreviewSuccess;

export type RenderLayoutPreviewSuccess = {
  __typename?: 'RenderLayoutPreviewSuccess';
  /** Created rendering job */
  job: RenderingJob;
};

export type RenderLayoutPreviewsError = {
  __typename?: 'RenderLayoutPreviewsError';
  /** Error messages */
  messages: Array<Scalars['String']['output']>;
};

export type RenderLayoutPreviewsInput = {
  /** Layouts to render preview for */
  items: Array<RenderLayoutPreviewInput>;
};

export type RenderLayoutPreviewsResult = RenderLayoutPreviewsError | RenderLayoutPreviewsSuccess;

export type RenderLayoutPreviewsSuccess = {
  __typename?: 'RenderLayoutPreviewsSuccess';
  /** Created rendering jobs */
  jobs: Array<RenderingJob>;
};

export type RenderLayoutsError = {
  __typename?: 'RenderLayoutsError';
  /** Error messages */
  messages: Array<Scalars['String']['output']>;
};

export type RenderLayoutsInput = {
  /** Layouts to render */
  items: Array<RenderLayoutInput>;
  /**
   * Render reflections
   * @default false
   */
  reflections?: InputMaybe<Scalars['Boolean']['input']>;
  /** Generic renderings settings */
  settings?: InputMaybe<Array<CreateRenderingJobSetting>>;
  /**
   * Render shadows
   * @default false
   */
  shadows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RenderLayoutsResult = RenderLayoutsError | RenderLayoutsSuccess;

export type RenderLayoutsSuccess = {
  __typename?: 'RenderLayoutsSuccess';
  /** Created rendering jobs */
  jobs: Array<RenderingJob>;
};

export type RenderingBackground = {
  __typename?: 'RenderingBackground';
  /** Background to use */
  background: Maybe<Background>;
  /** Id of background to use */
  id: Scalars['ID']['output'];
  /**
   * Absolute offset from the top left corner of the canvas
   * to the top left corner of the background image (in px)
   * @default (0, 0)
   */
  offset: Maybe<RenderingBackgroundOffset>;
  /**
   * Scale to use for background
   * @default 1
   */
  scale: Maybe<Scalars['Float']['output']>;
};

export type RenderingBackgroundInput = {
  /** Id of background to use */
  id: Scalars['ID']['input'];
  /**
   * Absolute offset from the top left corner of the canvas
   * to the top left corner of the background image (in px)
   * @default (0, 0)
   */
  offset?: InputMaybe<RenderingBackgroundOffsetInput>;
  /**
   * Scale to use for background
   * @default 1
   */
  scale?: InputMaybe<Scalars['Float']['input']>;
};

export type RenderingBackgroundOffset = {
  __typename?: 'RenderingBackgroundOffset';
  /**
   * Absolute offset from the left edge of the canvas
   * to the left edge of the background image (in px)
   */
  x: Scalars['Float']['output'];
  /**
   * Absolute offset from the top edge of the canvas
   * to the top edge of the background image (in px)
   */
  y: Scalars['Float']['output'];
};

export type RenderingBackgroundOffsetInput = {
  /**
   * Absolute offset from the left edge of the canvas
   * to the left edge of the background image (in px)
   */
  x: Scalars['Float']['input'];
  /**
   * Absolute offset from the top edge of the canvas
   * to the top edge of the background image (in px)
   */
  y: Scalars['Float']['input'];
};

export type RenderingJob = {
  __typename?: 'RenderingJob';
  /** Moment when job ended */
  end: Maybe<Scalars['Date']['output']>;
  /** Error message when job failed */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Objects rendered in this job */
  objects: Maybe<Array<RenderingJobObject>>;
  /** Result of job when it finished successfully */
  result: Maybe<RenderingJobResult>;
  /** Moment when job started */
  start: Maybe<Scalars['Date']['output']>;
  /** Current status */
  status: RenderingJobStatus;
};

export type RenderingJobGraphicObject = {
  __typename?: 'RenderingJobGraphicObject';
  /** Id of graphic to render */
  graphicId: Scalars['String']['output'];
};

export type RenderingJobObject = RenderingJobGraphicObject | RenderingJobPresentationObject;

export type RenderingJobOutput = {
  __typename?: 'RenderingJobOutput';
  /** Name */
  name: Scalars['String']['output'];
  /** Url to download output from */
  url: Scalars['String']['output'];
};

export type RenderingJobPresentationObject = {
  __typename?: 'RenderingJobPresentationObject';
  /** Id of presentation to render */
  presentationId: Scalars['String']['output'];
};

/** Result of rendering job, contains references to the outputs */
export type RenderingJobResult = {
  __typename?: 'RenderingJobResult';
  /** Url to download package with all output files from */
  outputPackageUrl: Maybe<Scalars['String']['output']>;
  /** Formatted outputs of the rendering */
  outputs: Maybe<Array<RenderingJobOutput>>;
  /** Id of rendering job the result is for */
  renderingJobId: Scalars['String']['output'];
  /** Url to download main rendering from */
  renderingUrl: Scalars['String']['output'];
};

export enum RenderingJobStatus {
  Created = 'Created',
  Failed = 'Failed',
  Finished = 'Finished',
  Running = 'Running'
}

export type RenderingObject = RenderingObjectGraphic | RenderingObjectPresentation;

export type RenderingObjectBase = {
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Kind of rendering object */
  kind: RenderingObjectKind;
  /**
   * Offset of object
   * @default (0,0)
   */
  offset: Maybe<PackshotOffset>;
  /**
   * Scale factor of object
   * @default 1
   */
  scale: Maybe<Scalars['Float']['output']>;
};

export type RenderingObjectGraphic = RenderingObjectBase & {
  __typename?: 'RenderingObjectGraphic';
  /** Graphic */
  graphic: Maybe<Graphic>;
  /** Id of graphic */
  graphicId: Maybe<Scalars['ID']['output']>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Kind of rendering object */
  kind: RenderingObjectKind;
  /**
   * Offset of object
   * @default (0,0)
   */
  offset: Maybe<PackshotOffset>;
  /**
   * Scale factor of object
   * @default 1
   */
  scale: Maybe<Scalars['Float']['output']>;
};

export enum RenderingObjectKind {
  /** Rendering object is a graphic */
  Graphic = 'graphic',
  /** Rendering object is a presentation with product inputs */
  Presentation = 'presentation'
}

export type RenderingObjectPresentation = RenderingObjectBase & {
  __typename?: 'RenderingObjectPresentation';
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Kind of rendering object */
  kind: RenderingObjectKind;
  /**
   * Offset of object
   * @default (0,0)
   */
  offset: Maybe<PackshotOffset>;
  /** Presentation */
  presentation: Maybe<Presentation>;
  /** Id of presentation */
  presentationId: Maybe<Scalars['ID']['output']>;
  /** Product inputs to use for rendering */
  productInputs: Maybe<Array<RenderingObjectProductInput>>;
  /**
   * Scale factor of object
   * @default 1
   */
  scale: Maybe<Scalars['Float']['output']>;
};

export type RenderingObjectProductInput = {
  __typename?: 'RenderingObjectProductInput';
  /** Url to file to use */
  fileUrl: Scalars['String']['output'];
  /** Identifier of product input */
  identifier: Scalars['String']['output'];
};

export type RenderingSetting = {
  __typename?: 'RenderingSetting';
  description: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<RenderingSettingOption>;
};

export type RenderingSettingOption = {
  __typename?: 'RenderingSettingOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RenderingSettings = {
  __typename?: 'RenderingSettings';
  settings: Array<RenderingSetting>;
};

export type SubBrand = {
  __typename?: 'SubBrand';
  /** Unique identifier of the sub-brand */
  id: Scalars['ID']['output'];
  /** Name of the sub-brand */
  name: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribes for layout rendering progress changes */
  layoutRenderingProgressChanged: Layout;
  /** Subscribes for layout thumbnail changes */
  layoutThumbnailChanged: Layout;
};


export type SubscriptionLayoutRenderingProgressChangedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionLayoutThumbnailChangedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Subsidiary = {
  __typename?: 'Subsidiary';
  /** Unique identifier of the subsidiary */
  id: Scalars['ID']['output'];
  /** Name of the subsidiary */
  name: Scalars['String']['output'];
};

export type TagsFilter = {
  /** Returns items that have any of the specified tags */
  anyOf?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLayoutInput = {
  /** Aspect ratio the layout will be rendered in */
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  /** New name of layout */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Id of new project of the layout */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Setup of background to use */
  renderingBackground?: InputMaybe<RenderingBackgroundInput>;
  /** Objects to render */
  renderingObjects?: InputMaybe<Array<UpdateRenderingObjectInput>>;
  /** Status */
  status?: InputMaybe<LayoutStatus>;
};

export type UpdateProductInput = {
  /**
   * Indicates if the product is approved.
   * Only approved products will generate presentation assets and are displayed in the UI
   */
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifiers of clients the product is for */
  clientIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Id of flight in Coach */
  flightId?: InputMaybe<Scalars['String']['input']>;
  /** Possible inputs for product */
  inputs?: InputMaybe<Array<CreateProductInputInput>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Presentations for product */
  presentations?: InputMaybe<Array<CreateProductPresentationInput>>;
};

export type UpdateProjectInput = {
  /** New name of project */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Workspace to move the project to */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRenderingObjectInput = {
  /** Id of graphic */
  graphicId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Id of rendering object to update
   * If not set a new rendering object is created
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Offset of object
   * @default (0,0)
   */
  offset?: InputMaybe<PackshotOffsetInput>;
  /** Id of presentation */
  presentationId?: InputMaybe<Scalars['ID']['input']>;
  /** Product inputs to use for rendering */
  productInputs?: InputMaybe<Array<UpdateRenderingObjectProductInputInput>>;
  /**
   * Scale factor of object
   * @default 1
   */
  scale?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateRenderingObjectProductInputInput = {
  /**
   * File to use
   * If not set the existing product input is kept.
   * If an existing product input is not set in the array, it is deleted.
   */
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  /** Identifier of product input */
  identifier: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  /** Active client */
  activeClient: Maybe<Client>;
  /** Ids of active client */
  activeClientId: Maybe<Scalars['String']['output']>;
  /** Ids of clients the user belongs to */
  clientIds: Maybe<Array<Scalars['String']['output']>>;
  /** Clients the user belongs to */
  clients: Maybe<Array<Client>>;
  /** Mail address of user */
  email: Maybe<Scalars['String']['output']>;
  /** Name of user */
  name: Maybe<Scalars['String']['output']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  /** Default aspect ratio to use for layouts in the workspace */
  defaultAspectRatio: Maybe<Scalars['Float']['output']>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Projects that belong to this workspace */
  projects: Maybe<Array<Project>>;
  /** Indicates if logged in user has read-only access to the workspace */
  readOnly: Maybe<Scalars['Boolean']['output']>;
  /** Subsidiary the workspace belongs to */
  subsidiary: Maybe<Scalars['String']['output']>;
};

export type WorkspaceFilter = {
  /** Filter by name */
  name?: InputMaybe<NameFilter>;
  /** Filter by access */
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkspaceQuery = {
  /** Filter to use */
  filter?: InputMaybe<WorkspaceFilter>;
  /** Pagination to use */
  pagination?: InputMaybe<Pagination>;
  /** Fields to sort */
  sort?: InputMaybe<Array<WorkspaceSort>>;
};

export type WorkspaceSort = {
  /**
   * Indicates if the sort should be descending.
   * By default it is sorted ascending.
   */
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  /** What field to sort by */
  field: WorkspaceSortField;
};

/** Possible fields to sort by */
export enum WorkspaceSortField {
  Name = 'Name'
}

export type CreateGraphicMutationVariables = Exact<{
  input: CreateGraphicInput;
}>;


export type CreateGraphicMutation = { __typename?: 'Mutation', createGraphic:
    | { __typename?: 'CreateGraphicError', message: string }
    | { __typename?: 'CreateGraphicSuccess', graphic: { __typename?: 'Graphic', id: string, name: string | null, asset: { __typename?: 'Asset', url: string } } }
   };

export type GraphicFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GraphicFiltersQuery = { __typename?: 'Query', graphicFilters: Array<{ __typename?: 'FieldFilterDefinition', fieldName: string, name: string, options: Array<{ __typename?: 'FieldFilterOption', label: string, value: string }> }> };

export type GraphicByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GraphicByIdQuery = { __typename?: 'Query', graphic: { __typename?: 'Graphic', id: string, name: string | null, previewUrl: string, asset: { __typename?: 'Asset', width: number, height: number } } };

export type GraphicsQueryVariables = Exact<{
  query?: InputMaybe<GraphicQuery>;
}>;


export type GraphicsQuery = { __typename?: 'Query', graphics: Array<{ __typename?: 'Graphic', id: string, name: string | null, asset: { __typename?: 'Asset', thumbnailUrl: string, url: string, width: number, height: number } }> };

export type GetLayoutLatestRenderingJobQueryVariables = Exact<{
  layoutId: Scalars['ID']['input'];
}>;


export type GetLayoutLatestRenderingJobQuery = { __typename?: 'Query', layout: { __typename?: 'Layout', latestRenderingJob: { __typename?: 'RenderingJob', id: string, result: { __typename?: 'RenderingJobResult', renderingUrl: string, outputPackageUrl: string | null, outputs: Array<{ __typename?: 'RenderingJobOutput', name: string, url: string }> | null } | null } | null } };

export type GetLayoutPreviewRenderingJobQueryVariables = Exact<{
  layoutId: Scalars['ID']['input'];
}>;


export type GetLayoutPreviewRenderingJobQuery = { __typename?: 'Query', layout: { __typename?: 'Layout', previewRenderingJob: { __typename?: 'RenderingJob', result: { __typename?: 'RenderingJobResult', renderingUrl: string } | null } | null } };

export type BackgroundFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type BackgroundFiltersQuery = { __typename?: 'Query', backgroundFilters: Array<{ __typename?: 'FieldFilterDefinition', fieldName: string, name: string, options: Array<{ __typename?: 'FieldFilterOption', label: string, value: string }> }> };

export type GetBackgroundQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBackgroundQuery = { __typename?: 'Query', background: { __typename?: 'Background', id: string, name: string | null, url: string } };

export type BackgroundsQueryVariables = Exact<{
  query?: InputMaybe<BackgroundQuery>;
}>;


export type BackgroundsQuery = { __typename?: 'Query', backgrounds: Array<{ __typename?: 'Background', id: string, name: string | null, tags: Array<string>, thumbnailUrl: string, url: string }> };

export type CreateBackgroundMutationVariables = Exact<{
  input: CreateBackgroundInput;
}>;


export type CreateBackgroundMutation = { __typename?: 'Mutation', createBackground:
    | { __typename?: 'CreateBackgroundError', message: string }
    | { __typename?: 'CreateBackgroundSuccess', background: { __typename?: 'Background', id: string, name: string | null, tags: Array<string>, thumbnailUrl: string, url: string } }
   };

export type CreateLayoutMutationVariables = Exact<{
  input: CreateLayoutInput;
}>;


export type CreateLayoutMutation = { __typename?: 'Mutation', createLayout: { __typename?: 'Layout', name: string | null, id: string, createdAt: string, status: LayoutStatus, projectId: string | null } };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', name: string | null } };

export type DeleteLayoutMutationVariables = Exact<{
  deleteLayoutId: Scalars['ID']['input'];
}>;


export type DeleteLayoutMutation = { __typename?: 'Mutation', deleteLayout: { __typename?: 'Layout', id: string } };

export type DeleteProjectMutationVariables = Exact<{
  deleteProjectId: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'Project', id: string } };

export type DuplicateLayoutMutationVariables = Exact<{
  input: DuplicateLayoutInput;
}>;


export type DuplicateLayoutMutation = { __typename?: 'Mutation', duplicateLayout: { __typename?: 'Layout', name: string | null, id: string, createdAt: string, projectId: string | null, status: LayoutStatus, thumbnailUrl: string | null, renderingProgress: LayoutRenderingProgress | null, renderingBackground: { __typename?: 'RenderingBackground', id: string, scale: number | null, offset: { __typename?: 'RenderingBackgroundOffset', y: number, x: number } | null, background: { __typename?: 'Background', id: string, name: string | null, tags: Array<string>, url: string, thumbnailUrl: string } | null } | null, renderingObjects: Array<
      | { __typename: 'RenderingObjectGraphic', id: string, scale: number | null, offset: { __typename?: 'PackshotOffset', x: number, y: number } | null }
      | { __typename: 'RenderingObjectPresentation', id: string, scale: number | null, presentationId: string | null, offset: { __typename?: 'PackshotOffset', x: number, y: number } | null }
    > | null } };

export type DuplicateProjectMutationVariables = Exact<{
  input: DuplicateProjectInput;
}>;


export type DuplicateProjectMutation = { __typename?: 'Mutation', duplicateProject: { __typename?: 'Project', name: string | null } };

export type GetLayoutBasicQueryVariables = Exact<{
  layoutId: Scalars['ID']['input'];
}>;


export type GetLayoutBasicQuery = { __typename?: 'Query', layout: { __typename?: 'Layout', id: string, name: string | null, status: LayoutStatus, createdAt: string, renderingProgress: LayoutRenderingProgress | null, projectId: string | null } };

export type LayoutRenderingProgressChangedSubscriptionVariables = Exact<{
  layoutRenderingProgressChangedId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LayoutRenderingProgressChangedSubscription = { __typename?: 'Subscription', layoutRenderingProgressChanged: { __typename?: 'Layout', id: string, status: LayoutStatus, renderingProgress: LayoutRenderingProgress | null, readOnly: boolean | null, previewRenderingJob: { __typename?: 'RenderingJob', result: { __typename?: 'RenderingJobResult', renderingUrl: string } | null } | null, latestRenderingJob: { __typename?: 'RenderingJob', result: { __typename?: 'RenderingJobResult', renderingUrl: string } | null } | null } };

export type LayoutThumbnailChangedSubscriptionVariables = Exact<{
  layoutId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LayoutThumbnailChangedSubscription = { __typename?: 'Subscription', layoutThumbnailChanged: { __typename?: 'Layout', id: string, thumbnailUrl: string | null } };

export type GetLayoutQueryVariables = Exact<{
  layoutId: Scalars['ID']['input'];
}>;


export type GetLayoutQuery = { __typename?: 'Query', layout: { __typename?: 'Layout', id: string, name: string | null, status: LayoutStatus, createdAt: string, renderingProgress: LayoutRenderingProgress | null, projectId: string | null, readOnly: boolean | null, aspectRatio: number | null, project: { __typename?: 'Project', workspace: { __typename?: 'Workspace', id: string, defaultAspectRatio: number | null } | null } | null, previewRenderingJob: { __typename?: 'RenderingJob', id: string, status: RenderingJobStatus, result: { __typename?: 'RenderingJobResult', renderingUrl: string } | null } | null, latestRenderingJob: { __typename?: 'RenderingJob', id: string, status: RenderingJobStatus, objects: Array<
        | { __typename: 'RenderingJobGraphicObject' }
        | { __typename: 'RenderingJobPresentationObject', presentationId: string }
      > | null, result: { __typename?: 'RenderingJobResult', renderingUrl: string } | null } | null, renderingBackground: { __typename?: 'RenderingBackground', id: string, scale: number | null, background: { __typename?: 'Background', id: string, name: string | null, url: string, tags: Array<string> } | null, offset: { __typename?: 'RenderingBackgroundOffset', x: number, y: number } | null } | null, renderingObjects: Array<
      | { __typename: 'RenderingObjectGraphic', id: string, kind: RenderingObjectKind, scale: number | null, graphicId: string | null, offset: { __typename?: 'PackshotOffset', x: number, y: number } | null }
      | { __typename: 'RenderingObjectPresentation', id: string, kind: RenderingObjectKind, scale: number | null, presentationId: string | null, offset: { __typename?: 'PackshotOffset', x: number, y: number } | null, presentation:
          | { __typename?: 'Animation', id: string, type: PresentationType, productId: string | null, url: string, name: string | null, thumbnailUrl: string, referenceResolution: number, asset: { __typename?: 'Asset', width: number, height: number } | null }
          | { __typename?: 'Perspective', id: string, type: PresentationType, productId: string | null, url: string, name: string | null, thumbnailUrl: string, referenceResolution: number, asset: { __typename?: 'Asset', width: number, height: number } | null }
         | null, productInputs: Array<{ __typename?: 'RenderingObjectProductInput', identifier: string, fileUrl: string }> | null }
    > | null } };

export type GetLayoutsQueryVariables = Exact<{
  query?: InputMaybe<LayoutQuery>;
}>;


export type GetLayoutsQuery = { __typename?: 'Query', layouts: { __typename?: 'LayoutQueryResult', items: Array<{ __typename?: 'Layout', id: string, name: string | null, status: LayoutStatus, thumbnailUrl: string | null, renderingProgress: LayoutRenderingProgress | null, readOnly: boolean | null }> | null } };

export type RenderLayoutPreviewMutationVariables = Exact<{
  input: RenderLayoutPreviewInput;
}>;


export type RenderLayoutPreviewMutation = { __typename?: 'Mutation', renderLayoutPreview:
    | { __typename?: 'RenderLayoutPreviewError', message: string }
    | { __typename?: 'RenderLayoutPreviewSuccess', job: { __typename?: 'RenderingJob', id: string } }
   };

export type ProductFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductFiltersQuery = { __typename?: 'Query', productFilters: Array<{ __typename?: 'FieldFilterDefinition', fieldName: string, name: string, options: Array<{ __typename?: 'FieldFilterOption', label: string, value: string }> }> };

export type ProductInputsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ProductInputsQuery = { __typename?: 'Query', product: { __typename?: 'Product', inputs: Array<{ __typename?: 'ProductInput', id: string, identifier: string, name: string | null }> | null } | null };

export type GetProductPresentationsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetProductPresentationsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, name: string | null, perspectives: Array<{ __typename?: 'Perspective', id: string, type: PresentationType, name: string | null, thumbnailUrl: string, url: string, referenceResolution: number, asset: { __typename?: 'Asset', width: number, height: number } | null }> | null, animations: Array<{ __typename?: 'Animation', id: string, type: PresentationType, name: string | null, thumbnailUrl: string, url: string, referenceResolution: number, asset: { __typename?: 'Asset', width: number, height: number } | null }> | null } | null };

export type ProductsQueryVariables = Exact<{
  query?: InputMaybe<ProductQuery>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, name: string | null, thumbnailUrl: string | null, animations: Array<{ __typename?: 'Animation', id: string, type: PresentationType, productId: string | null, name: string | null, thumbnailUrl: string, url: string, referenceResolution: number, asset: { __typename?: 'Asset', width: number, height: number } | null }> | null, perspectives: Array<{ __typename?: 'Perspective', id: string, type: PresentationType, productId: string | null, name: string | null, thumbnailUrl: string, url: string, referenceResolution: number, asset: { __typename?: 'Asset', width: number, height: number } | null }> | null }> };

export type GetProjectByIdQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectByIdQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, name: string | null, workspaceId: string | null, readOnly: boolean | null } };

export type ProjectsQueryVariables = Exact<{
  query?: InputMaybe<ProjectQuery>;
}>;


export type ProjectsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectQueryResult', items: Array<{ __typename?: 'Project', id: string, name: string | null, layoutCount: number | null, lastEditedAt: string | null, readOnly: boolean | null, workspace: { __typename?: 'Workspace', name: string, id: string } | null }> | null } };

export type RenderLayoutMutationVariables = Exact<{
  input: RenderLayoutInput;
}>;


export type RenderLayoutMutation = { __typename?: 'Mutation', renderLayout:
    | { __typename?: 'CreateRenderingJobError', message: string }
    | { __typename?: 'CreateRenderingJobSuccess', job: { __typename?: 'RenderingJob', id: string } }
   };

export type RenderLayoutsMutationVariables = Exact<{
  input: RenderLayoutsInput;
}>;


export type RenderLayoutsMutation = { __typename?: 'Mutation', renderLayouts:
    | { __typename?: 'RenderLayoutsError', messages: Array<string> }
    | { __typename?: 'RenderLayoutsSuccess', jobs: Array<{ __typename?: 'RenderingJob', id: string }> }
   };

export type RenderingSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type RenderingSettingsQuery = { __typename?: 'Query', renderingSettings: { __typename?: 'RenderingSettings', settings: Array<{ __typename?: 'RenderingSetting', identifier: string, label: string, description: string | null, options: Array<{ __typename?: 'RenderingSettingOption', label: string, value: string }> }> } };

export type UpdateLayoutMutationVariables = Exact<{
  updateLayoutId: Scalars['ID']['input'];
  data: UpdateLayoutInput;
}>;


export type UpdateLayoutMutation = { __typename?: 'Mutation', updateLayout: { __typename?: 'Layout', name: string | null } };

export type UpdateProjectMutationVariables = Exact<{
  updateProjectId: Scalars['ID']['input'];
  data: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', name: string | null, activeClient: { __typename?: 'Client', logoUrl: string | null, canUseShadowsAndReflections: boolean, canAdaptLabel: boolean, defaultAspectRatio: number | null } | null } | null };

export type WorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspacesQuery = { __typename?: 'Query', workspaces: Array<{ __typename?: 'Workspace', id: string, name: string, subsidiary: string | null, readOnly: boolean | null, projects: Array<{ __typename?: 'Project', id: string, name: string | null }> | null }> };

export type GetLayoutJobsQueryVariables = Exact<{
  layoutId: Scalars['ID']['input'];
}>;


export type GetLayoutJobsQuery = { __typename?: 'Query', layout: { __typename?: 'Layout', previewRenderingJob: { __typename?: 'RenderingJob', result: { __typename?: 'RenderingJobResult', renderingUrl: string } | null } | null, latestRenderingJob: { __typename?: 'RenderingJob', result: { __typename?: 'RenderingJobResult', renderingUrl: string } | null } | null } };

export type NextMaintenanceQueryVariables = Exact<{ [key: string]: never; }>;


export type NextMaintenanceQuery = { __typename?: 'Query', nextMaintenance: { __typename?: 'Maintenance', id: string, from: string, to: string } | null };


export const CreateGraphicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGraphic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGraphicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGraphic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGraphicSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"graphic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGraphicError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateGraphicMutation, CreateGraphicMutationVariables>;
export const GraphicFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GraphicFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"graphicFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GraphicFiltersQuery, GraphicFiltersQueryVariables>;
export const GraphicByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"graphicById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"graphic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewUrl"}}]}}]}}]} as unknown as DocumentNode<GraphicByIdQuery, GraphicByIdQueryVariables>;
export const GraphicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Graphics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GraphicQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"graphics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]} as unknown as DocumentNode<GraphicsQuery, GraphicsQueryVariables>;
export const GetLayoutLatestRenderingJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLayoutLatestRenderingJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"layout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latestRenderingJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"renderingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"outputPackageUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLayoutLatestRenderingJobQuery, GetLayoutLatestRenderingJobQueryVariables>;
export const GetLayoutPreviewRenderingJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLayoutPreviewRenderingJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"layout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewRenderingJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLayoutPreviewRenderingJobQuery, GetLayoutPreviewRenderingJobQueryVariables>;
export const BackgroundFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BackgroundFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BackgroundFiltersQuery, BackgroundFiltersQueryVariables>;
export const GetBackgroundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBackground"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetBackgroundQuery, GetBackgroundQueryVariables>;
export const BackgroundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Backgrounds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BackgroundQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgrounds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<BackgroundsQuery, BackgroundsQueryVariables>;
export const CreateBackgroundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBackground"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBackgroundInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBackground"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBackgroundSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBackgroundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBackgroundMutation, CreateBackgroundMutationVariables>;
export const CreateLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLayoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]} as unknown as DocumentNode<CreateLayoutMutation, CreateLayoutMutationVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const DeleteLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteLayoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteLayoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLayoutMutation, DeleteLayoutMutationVariables>;
export const DeleteProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteProjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteProjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DuplicateLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateLayoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"renderingBackground"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"x"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scale"}},{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"renderingObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingObjectBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scale"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingObjectPresentation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"presentationId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"renderingProgress"}}]}}]}}]} as unknown as DocumentNode<DuplicateLayoutMutation, DuplicateLayoutMutationVariables>;
export const DuplicateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DuplicateProjectMutation, DuplicateProjectMutationVariables>;
export const GetLayoutBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLayoutBasic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"layout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"renderingProgress"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]} as unknown as DocumentNode<GetLayoutBasicQuery, GetLayoutBasicQueryVariables>;
export const LayoutRenderingProgressChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"LayoutRenderingProgressChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layoutRenderingProgressChangedId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"layoutRenderingProgressChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layoutRenderingProgressChangedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"renderingProgress"}},{"kind":"Field","name":{"kind":"Name","value":"readOnly"}},{"kind":"Field","name":{"kind":"Name","value":"previewRenderingJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestRenderingJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LayoutRenderingProgressChangedSubscription, LayoutRenderingProgressChangedSubscriptionVariables>;
export const LayoutThumbnailChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"LayoutThumbnailChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"layoutThumbnailChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}}]} as unknown as DocumentNode<LayoutThumbnailChangedSubscription, LayoutThumbnailChangedSubscriptionVariables>;
export const GetLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"layout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"renderingProgress"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"readOnly"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAspectRatio"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewRenderingJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestRenderingJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingJobPresentationObject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"presentationId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"renderingBackground"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scale"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"renderingObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingObjectPresentation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scale"}},{"kind":"Field","name":{"kind":"Name","value":"presentationId"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceResolution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productInputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingObjectGraphic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scale"}},{"kind":"Field","name":{"kind":"Name","value":"graphicId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLayoutQuery, GetLayoutQueryVariables>;
export const GetLayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLayouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LayoutQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"layouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"renderingProgress"}},{"kind":"Field","name":{"kind":"Name","value":"readOnly"}}]}}]}}]}}]} as unknown as DocumentNode<GetLayoutsQuery, GetLayoutsQueryVariables>;
export const RenderLayoutPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenderLayoutPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenderLayoutPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderLayoutPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderLayoutPreviewSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderLayoutPreviewError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RenderLayoutPreviewMutation, RenderLayoutPreviewMutationVariables>;
export const ProductFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ProductFiltersQuery, ProductFiltersQueryVariables>;
export const ProductInputsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductInputs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ProductInputsQuery, ProductInputsQueryVariables>;
export const GetProductPresentationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductPresentations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"perspectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceResolution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"animations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceResolution"}}]}}]}}]}}]} as unknown as DocumentNode<GetProductPresentationsQuery, GetProductPresentationsQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"animations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceResolution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perspectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceResolution"}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const GetProjectByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProjectById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"readOnly"}}]}}]}}]} as unknown as DocumentNode<GetProjectByIdQuery, GetProjectByIdQueryVariables>;
export const ProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Projects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"layoutCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditedAt"}},{"kind":"Field","name":{"kind":"Name","value":"readOnly"}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsQuery, ProjectsQueryVariables>;
export const RenderLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenderLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenderLayoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRenderingJobSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRenderingJobError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RenderLayoutMutation, RenderLayoutMutationVariables>;
export const RenderLayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenderLayouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenderLayoutsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderLayouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderLayoutsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderLayoutsError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messages"}}]}}]}}]}}]} as unknown as DocumentNode<RenderLayoutsMutation, RenderLayoutsMutationVariables>;
export const RenderingSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RenderingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RenderingSettingsQuery, RenderingSettingsQueryVariables>;
export const UpdateLayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateLayoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLayoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLayout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateLayoutId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateLayoutMutation, UpdateLayoutMutationVariables>;
export const UpdateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateProjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateProjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"activeClient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"canUseShadowsAndReflections"}},{"kind":"Field","name":{"kind":"Name","value":"canAdaptLabel"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAspectRatio"}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const WorkspacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiary"}},{"kind":"Field","name":{"kind":"Name","value":"readOnly"}}]}}]}}]} as unknown as DocumentNode<WorkspacesQuery, WorkspacesQueryVariables>;
export const GetLayoutJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLayoutJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"layout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewRenderingJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestRenderingJob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLayoutJobsQuery, GetLayoutJobsQueryVariables>;
export const NextMaintenanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NextMaintenance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextMaintenance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]} as unknown as DocumentNode<NextMaintenanceQuery, NextMaintenanceQueryVariables>;